export const sendToGA = (
    eventName:
        | BrandDetailsTrackEventName
        | DiscountDetailsTrackEventName
        | GenericEventsName
        | LoginEventName
        | PluginTrackEventName,
    eventParams?: IGAMappedEventParams,
) => typeof gtag !== "undefined" && gtag("event", eventName, cleanedEventModel(eventParams));

interface IGAMappedEventParams {
    variant?: string | number;
    campaign?:string | number;
    brandName?:string | number;
    discountName?:string | number;
    channel?:string | number;
    param1?:string | number;
    param2?:string | number;
    param3?:string | number;
}

type PluginTrackEventName = "plugin_goToStore";

type BrandDetailsTrackEventName = "brandDetails" | "cshbck_brandLocationOnlineClick";
export const sendToGTMBrandDetails = (eventName: BrandDetailsTrackEventName, brandName: string) =>
    sendToGA(eventName, { brandName });

type DiscountDetailsTrackEventName =
    | "discDetails"
    | "cshbck_discountLocationOnlineClick"
    | "cshbck_outboundNotLoggedInBtn"
    | "common_exit"
    | "common_back";
export const sendToGTMDiscountDetails = (
    eventName: DiscountDetailsTrackEventName,
    brandName: string,
    discountName: string,
) => sendToGA(eventName, { brandName, discountName });

type GenericEventsName =
    | "cshbck_outboundNotLoggedInBtn"
    | "cshbck_outboundInfoGoToStore"
    | "common_registerIn"
    | "common_registerSuccess"
    | "common_login"
    | "login_apple"
    | "login_google"
    | "login_facebook"
    | "login_onet"
    | "login_email"
    | "rgstr_emailRegister"
    | "rgstr_google"
    | "rgstr_facebook"
    | "rgstr_apple"
    | "rgstr_onet"
    | `rgstr_${string}`;

export const sendToGTMEventClick: (eventName: GenericEventsName) => void = sendToGA;

type LoginEventName = "sign_up" | "login";
export type LoginProviderName = "Facebook" | "Onet" | "Apple" | "Google" | "Email";
export const sendToGALoginEvent = (eventName: LoginEventName, providerName: LoginProviderName, variant?: string) =>
    sendToGA(eventName, { channel: providerName , variant:variant });


const cleanedEventModel = (eventModel?: object | null) =>
    Object.fromEntries(Object.entries(eventModel ?? {}).filter(([, value]) => value != null));
